import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M2 18a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2H2v-2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M20 16a8 8 0 1 0-16 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 4v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 4h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ConciergeBell";
const ConciergeBell = memo(themed(Icon));
export {
  ConciergeBell
};
//# sourceMappingURL=concierge-bell.js.map
